"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ofType = exports.ofID = exports.of = exports["default"] = void 0;

var activities = function activities(_ref) {
  var activities = _ref.activities;
  return activities;
};

var of = function of(predicate) {
  return function (state) {
    return activities(state).filter(predicate);
  };
};

exports.of = of;

var ofID = function ofID(targetID) {
  return of(function (_ref2) {
    var id = _ref2.id;
    return id === targetID;
  });
};

exports.ofID = ofID;

var ofType = function ofType(targetType) {
  return of(function (_ref3) {
    var type = _ref3.type;
    return type === targetType;
  });
};

exports.ofType = ofType;
var _default = activities;
exports["default"] = _default;